import { makeStyles, createMuiTheme } from '@material-ui/core/styles'
import ThemeProvider from './ThemeProviderAdapter'
import 'typeface-roboto'

const useJss = (styles) => makeStyles(() => styles)

const createTheme = (theme) => createMuiTheme(theme)

export {
  ThemeProvider,
  createTheme,
  useJss,
}
